import { render, staticRenderFns } from "./s-stepper.vue?vue&type=template&id=4f6d7504&scoped=true"
import script from "./s-stepper.vue?vue&type=script&setup=true&lang=js"
export * from "./s-stepper.vue?vue&type=script&setup=true&lang=js"
import style0 from "./s-stepper.vue?vue&type=style&index=0&id=4f6d7504&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f6d7504",
  null
  
)

export default component.exports